import $ from 'jquery';

function togglePageSelection() {
    $('.layout__item-linked-in-page-container').hide();
    $('.layout__item-facebook-page-container').hide();
    $('.layout__item-source_reference-container').show();

    if ($('#form__field--import_type_id option:selected').data('reference') == 'linkedinpage') {
        $('.layout__item-source_reference-container').hide();
        $('.layout__item-linked-in-page-container').show();
    } else if ($('#form__field--import_type_id option:selected').data('reference') == 'facebook_page') {
        $('.layout__item-source_reference-container').hide();
        $('.layout__item-facebook-page-container').show();
    }
}

export default () => {
    $('#form__field--import_type_id').on('change', function () {
        togglePageSelection();
    });

    togglePageSelection();
}
